<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/175KmTw/tc-custom/9781467432009.jpg?1730409135994" alt="This image is the cover for the book Princess Ka'iulani, Incredible Lives for Young Readers (ILYR)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Princess Ka'iulani, Incredible Lives for Young Readers (ILYR)
      </h1>
      <p class="bookDescription body article font2">
        <p>On March 1, 1893, Princess Ka’iulani, the seventeen-year-old crown princess of Hawaii, stepped onto the pier at New York City. She was greeted by a crowd of reporters and onlookers who knew that, in many ways, she stood at a crossroads in history. Fully aware of the significance of her visit, she prayed that she could help persuade the American government to return her beautiful islands to the Hawaiian people.<br/><br/> This biography tells the fascinating—and little-known—story of Princess Ka’iulani’s life and courageous fight for Hawaiian independence. Using many newly translated journals and letters, Sharon Linnéa introduces young readers to the most beloved figure in Hawaiian history, and one of America’s most overlooked Christian heroines.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sharon Linnea
      </h2>
      
      <p class="authorDescription body article">Sharon Linnéa grew up in Elmhurst, Illinois andattended Wheaton College for two years. She received herB.A. in English from New York University in 1978, afterwhich she worked as a book editor and staff writer for fournational magazines.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?54c82f32